// extracted by mini-css-extract-plugin
export var hidden = "_74-1";
export var visible = "_74-0";